var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPeoplePin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54.108,
    height: 71.633,
    viewBox: "0 0 54.108 71.633",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_4421",
    x: 0,
    y: 0,
    width: 54.108,
    height: 71.633,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4818",
    "data-name": "Group 4818",
    transform: "translate(17632 14683.634)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4029",
    "data-name": "Group 4029",
    transform: "translate(-17623 -14677.634)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_376",
    "data-name": "Ellipse 376",
    cx: 13.721,
    cy: 13.721,
    r: 13.721,
    transform: "translate(4.364 4.068)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4027",
    "data-name": "Group 4027"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4028",
    "data-name": "Group 4028"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_4421)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4421-2",
    "data-name": "Path 4421",
    d: "M18.054,0A18.054,18.054,0,0,0,0,18.054c0,9.971,18.054,35.579,18.054,35.579S36.108,28.025,36.108,18.054A18.054,18.054,0,0,0,18.054,0m0,30.965A12.911,12.911,0,1,1,30.965,18.054,12.911,12.911,0,0,1,18.054,30.965",
    transform: "translate(9 6)",
    fill: "#0d47a1"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "user.1",
    transform: "translate(-17610.566 -14666.396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3726",
    "data-name": "Path 3726",
    d: "M102.422,3.211A3.211,3.211,0,1,1,99.211,0,3.211,3.211,0,0,1,102.422,3.211Z",
    transform: "translate(-93.592)",
    fill: "#888",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3727",
    "data-name": "Path 3727",
    d: "M7.867,288H7.448a4.368,4.368,0,0,1-3.658,0H3.372A3.372,3.372,0,0,0,0,291.371v1.044a1.2,1.2,0,0,0,1.2,1.2h8.83a1.2,1.2,0,0,0,1.2-1.2v-1.044A3.372,3.372,0,0,0,7.868,288Z",
    transform: "translate(0 -280.775)",
    fill: "#0d47a1"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPeoplePin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/People-pin.5243a3ae5a19744275a3b82e95e5f7f2.svg";